import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { getApi } from "../../services/api/globalApi";
import BrrowerAllInfo from "../../components/loan/loan-all-info/BrrowerAllInfo";
import GuarantorAllInfo from "../../components/loan/loan-all-info/GuarantorAllInfo";
import { useReactToPrint } from "react-to-print";
import generatePDF from "react-to-pdf";
import StepsAllInfo from "../../components/loan/loan-all-info/StepsAllInfo";

function LoanAllInfo() {
  const params = useParams();

  const [data, setData] = useState(null);
  const getLoan = async () => {
    const path = `/admin/loans/${params?.id}`;
    try {
      const response = await getApi({ path });
      setData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getLoan();
  }, []);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Visitor Pass",
    bodyClass: "rtlDir",
    onAfterPrint: () => console.log("Printed PDF successfully!"),
  });

  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location?.pathname]);

  return (
    <>
      <div className="w-11/12 mx-auto mt-12 flex items-center justify-between px-4">
        <div className="w-11/12 flex gap-3 items-center mx-auto">
          <button
            onClick={handlePrint}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            پرینت
          </button>
          <button
            onClick={() => generatePDF(componentRef, { filename: "page.pdf" })}
            type="button"
            className="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
          >
            دانلود PDF
          </button>
        </div>
        <p
          onClick={() => navigate(-1)}
          className="cursor-pointer focus:outline-none text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
        >
          بازگشت
        </p>
      </div>
      <div
        ref={componentRef}
        className="w-11/12 mx-auto  border border-gray-200 rounded-lg my-6 bg-white shadow-sm p-6"
      >
        <h3 class="mb-4 text-lg font-medium leading-none text-gray-900 dark:text-white">
          اطلاعات کلی وام آقا/خانوم کاربر
        </h3>
        <BrrowerAllInfo data={data} />
        <span className="w-full h-[2px] bg-gray-500 rounded-xl block mt-4 mb-6"></span>
        <GuarantorAllInfo data={data} />
      </div>
       <StepsAllInfo data={data} />
    </>
  );
}

export default LoanAllInfo;
